/* Sicilus friction fixes - localized customer-facing copy - 20/06/2026 */
(function () {
  'use strict';

  var I18N = {
    it: {
      cart: 'Carrello',
      quantityNotAvailable: 'La quantità richiesta non è disponibile.',
      cartError: "Si è verificato un errore nell'aggiornamento del carrello. Riprova.",
      cartToast: 'Carrello aggiornato',
      checkout: 'Vai al checkout',
      newsletterText: 'Iscriviti alla nostra newsletter per ricevere aggiornamenti su novità e promozioni riservate',
      newsletterButton: 'Iscriviti'
    },
    fr: {
      cart: 'Panier',
      quantityNotAvailable: 'La quantité demandée n’est pas disponible.',
      cartError: 'Une erreur est survenue lors de la mise à jour du panier. Veuillez réessayer.',
      cartToast: 'Panier mis à jour',
      checkout: 'Passer au paiement',
      newsletterText: 'Inscrivez-vous à notre newsletter pour recevoir les nouveautés et les offres réservées',
      newsletterButton: "S'inscrire"
    },
    de: {
      cart: 'Warenkorb',
      quantityNotAvailable: 'Die gewünschte Menge ist nicht verfügbar.',
      cartError: 'Beim Aktualisieren des Warenkorbs ist ein Fehler aufgetreten. Bitte versuche es erneut.',
      cartToast: 'Warenkorb aktualisiert',
      checkout: 'Zur Kasse',
      newsletterText: 'Abonnieren Sie unseren Newsletter und erhalten Sie Neuigkeiten und exklusive Angebote',
      newsletterButton: 'Abonnieren'
    },
    es: {
      cart: 'Carrito',
      quantityNotAvailable: 'La cantidad solicitada no está disponible.',
      cartError: 'Se ha producido un error al actualizar el carrito. Inténtalo de nuevo.',
      cartToast: 'Carrito actualizado',
      checkout: 'Finalizar compra',
      newsletterText: 'Suscríbete a nuestro boletín para recibir novedades y promociones exclusivas',
      newsletterButton: 'Suscribirse'
    },
    en: {
      cart: 'Cart',
      quantityNotAvailable: 'The requested quantity is not available.',
      cartError: 'There was an error updating the cart. Please try again.',
      cartToast: 'Cart updated',
      checkout: 'Checkout',
      newsletterText: 'Subscribe to our newsletter to receive updates and exclusive promotions',
      newsletterButton: 'Subscribe'
    }
  };

  function currentLang() {
    return (document.documentElement.getAttribute('lang') || 'it').split('-')[0].toLowerCase();
  }

  function copy() {
    return I18N[currentLang()] || I18N.en;
  }

  function normalize(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function replaceTranslationMissing(root) {
    var c = copy();
    var locale = currentLang();
    var labels = {
      'products.product.quantity_not_available': c.quantityNotAvailable,
      'general.cart.error_message': c.cartError,
      'general.cart.toast_title': c.cartToast
    };

    try {
      if (window.themeHDN && window.themeHDN.extras) {
        if (window.themeHDN.extras.quantity) window.themeHDN.extras.quantity.notAvailable = c.quantityNotAvailable;
        if (window.themeHDN.extras.cart) {
          window.themeHDN.extras.cart.errorMessage = c.cartError;
          window.themeHDN.extras.cart.toastTitle = c.cartToast;
        }
      }
    } catch (error) {}

    (root || document).querySelectorAll('a, button, span, div, p, small').forEach(function (node) {
      if (node.children && node.children.length) return;
      var text = node.textContent || '';
      var next = text;
      Object.keys(labels).forEach(function (key) {
        var pattern = new RegExp('Translation missing:\\s*' + locale + '\\.' + key.replace(/\./g, '\\.'), 'gi');
        next = next.replace(pattern, labels[key]);
      });
      if (next !== text) node.textContent = next;
    });
  }

  function inCustomerCopyArea(element) {
    return !!(element && element.closest && element.closest('footer, .hdt-section-footer, .hdt-newsletter-parent, .hdt-newsletter-main, .hdt-site-top_nav, .hdt-toolbar, .trc-discount, #pellegriniBox, .hide_couponcode'));
  }

  function walkText(root, callback) {
    var scope = root || document.body || document;
    if (!scope) return;
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;
        if (!parent || /^(SCRIPT|STYLE|TEXTAREA|INPUT|NOSCRIPT)$/i.test(parent.tagName)) return NodeFilter.FILTER_REJECT;
        return callback(node, parent, true) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var node;
    while ((node = walker.nextNode())) callback(node, node.parentElement, false);
  }

  function replaceVisibleCopy(root) {
    var lang = currentLang();
    var c = copy();

    walkText(root, function (node, parent, testOnly) {
      var text = normalize(node.nodeValue);
      var scoped = inCustomerCopyArea(parent);
      var shouldChange = false;

      if (lang !== 'it' && scoped && text === I18N.it.newsletterText) shouldChange = true;
      if (lang !== 'it' && scoped && text === I18N.it.newsletterButton) shouldChange = true;
      if (lang !== 'it' && scoped && text === I18N.it.cart) shouldChange = true;
      if (scoped && text === 'Check out') shouldChange = true;

      if (testOnly) return shouldChange;

      if (lang !== 'it' && text === I18N.it.newsletterText) node.nodeValue = node.nodeValue.replace(I18N.it.newsletterText, c.newsletterText);
      if (lang !== 'it' && text === I18N.it.newsletterButton) node.nodeValue = node.nodeValue.replace(I18N.it.newsletterButton, c.newsletterButton);
      if (lang !== 'it' && text === I18N.it.cart) node.nodeValue = node.nodeValue.replace(I18N.it.cart, c.cart);
      if (text === 'Check out') node.nodeValue = node.nodeValue.replace('Check out', c.checkout);
      return true;
    });

    (root || document).querySelectorAll('input, button, a').forEach(function (node) {
      if (!inCustomerCopyArea(node)) return;
      ['value', 'aria-label', 'title'].forEach(function (attr) {
        var value = attr === 'value' ? node.value : node.getAttribute(attr);
        if (!value) return;
        var next = value;
        if (lang !== 'it') {
          if (normalize(next) === I18N.it.newsletterButton) next = c.newsletterButton;
          if (normalize(next) === I18N.it.cart) next = c.cart;
        }
        if (normalize(next) === 'Check out') next = c.checkout;
        if (next !== value) {
          if (attr === 'value') node.value = next;
          else node.setAttribute(attr, next);
        }
      });
    });
  }

  function apply(root) {
    replaceTranslationMissing(root || document);
    replaceVisibleCopy(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { apply(document); });
  } else {
    apply(document);
  }

  var timer;
  new MutationObserver(function (mutations) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      mutations.forEach(function (mutation) {
        if (!mutation.addedNodes) return;
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) apply(node);
        });
      });
    }, 80);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
